import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVolumeDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVolumeDown"><Path d="M13 2.97046V21.0296L5.8043 17.0001H1V7.00005H5.8043L13 2.97046Z" fill="currentColor"/><Path d="M23 11.25H15V12.75H23V11.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVolumeDown;
